import { IconInbox } from '@tabler/icons-react'

import { AstraChip, AstraSideNavItem, AstraTinyIndicator } from '~/astra'
import { useUnreadInboxEntriesQuery } from '~/components/Inbox/useInbox'
import { useInboxDrawer } from '~/components/Inbox/useInboxDrawer'
import { useFlag } from '~/hooks/useFlag'

export const InboxButton = () => {
    const { isLoading, data: unreadInboxEntriesCount } = useUnreadInboxEntriesQuery()
    const isInboxEnabled = useFlag('inbox')
    const { toggleDrawer } = useInboxDrawer()

    const showUnreadInboxEntriesIndicator = !isLoading && (unreadInboxEntriesCount ?? 0) > 0

    if (!isInboxEnabled) {
        return null
    }

    return (
        <div className="relative">
            <AstraSideNavItem
                icon={IconInbox}
                label="Innboks"
                type="action"
                onClick={toggleDrawer}
                rightSlot={
                    showUnreadInboxEntriesIndicator && (
                        <AstraChip label={unreadInboxEntriesCount} size="small" variant="outlined" data-test="unread-inbox-indicator" />
                    )
                }
            />
            {showUnreadInboxEntriesIndicator && <AstraTinyIndicator reduceMotion className="!right-[7px] !top-[2px]" />}
        </div>
    )
}
